import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { debounce } from 'lodash';
import QueryParamsProxy from '../../../utils/queryParamProxy';
import RouteParamConstants from '../../../utils/routeParamConstants';
import Screens from '../../index';
import UpgradeType from '../../UpgradeAccountFlow/UpgradeType';
import { casinoIdStatus as PlayerStatus } from '../../../api/PlayerInfoConstants';
import { isStar } from '../../../utils/targetApplication';
import { setPurchaseType } from '../../../state/actions/prePurchase';
import { setActiveConsumables, setVipRoomUnlocked } from '../../../state/actions/consumables';
import Logger from '../../../lib/analytics/logger';
import ERROR_CODE from '../../../utils/errorCodes';
import { EVENT_TYPES } from '../../../lib/analytics/constants';
import audio from '../../../utils/audio';
import AppInterface from '../../../api/AppInterface';
import { PURCHASE_RESPONSE, PURCHASE_TYPE, REG_EXP } from '../../../constants';
import { usePostOfferDetailMutation, usePostPurchaseOfferMutation } from '../../../state/query/rewardCenter';
import { useGetActiveConsumablesQuery } from '../../../state/query/shop';
import { fetchGameRooms } from '../../../state/query/games/utils';
import generateRender from '../../../utils/generateRender';

var useRewardCenterOfferDetails = function useRewardCenterOfferDetails(_ref) {
  var activeOffer = _ref.selectedOffer,
      purchaseResponse = _ref.purchaseResponse,
      setPurchaseResponse = _ref.setPurchaseResponse,
      RewardsImageBaseURL = _ref.RewardsImageBaseURL;

  var _useState = useState({
    terms: null,
    rewardtype: null,
    properties: null
  }),
      _useState2 = _slicedToArray(_useState, 2),
      offerDetails = _useState2[0],
      setOfferDetails = _useState2[1];

  var _usePostPurchaseOffer = usePostPurchaseOfferMutation(),
      _usePostPurchaseOffer2 = _slicedToArray(_usePostPurchaseOffer, 1),
      postPurchaseOffer = _usePostPurchaseOffer2[0];

  var _usePostOfferDetailMu = usePostOfferDetailMutation(),
      _usePostOfferDetailMu2 = _slicedToArray(_usePostOfferDetailMu, 1),
      postOfferDetail = _usePostOfferDetailMu2[0];

  var _useGetActiveConsumab = useGetActiveConsumablesQuery(),
      activeConsumables = _useGetActiveConsumab.data,
      refetchActiveConsumables = _useGetActiveConsumab.refetch;

  var dispatch = useDispatch();

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      property = _useState4[0],
      setProperty = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isVipPurchase = _useState6[0],
      setIsVipPurchase = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isLoading = _useState8[0],
      setIsLoading = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isPurchaseButtonDisabled = _useState10[0],
      setIsPurchaseButtonDisabled = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      showKycPopUp = _useState12[0],
      setShowKycPopUp = _useState12[1];

  var isFirstRender = useRef(true);

  var _useSelector = useSelector(function (state) {
    return {
      playerInfo: state.playerInfo,
      isVipRoomUnlocked: state.consumables.isVipRoomUnlocked,
      coin: state.coin,
      loyalty: state.loyalty
    };
  }, shallowEqual),
      _useSelector$playerIn = _useSelector.playerInfo,
      memberLevel = _useSelector$playerIn.memberLevel,
      KYCResult = _useSelector$playerIn.KYCResult,
      casinoIdStatus = _useSelector$playerIn.casinoIdStatus,
      casinoId = _useSelector$playerIn.casinoId,
      isAccountLinked = _useSelector$playerIn.isAccountLinked,
      isVipRoomUnlocked = _useSelector.isVipRoomUnlocked,
      coin = _useSelector.coin,
      loyalty = _useSelector.loyalty;

  var terms = offerDetails.terms,
      rewardtype = offerDetails.rewardtype,
      properties = offerDetails.properties;
  var termsByRegex = terms && terms.split(REG_EXP.https);

  var _ref2 = termsByRegex || [],
      _ref3 = _slicedToArray(_ref2, 2),
      termsText = _ref3[0],
      termsUrl = _ref3[1];

  var propertyList = useMemo(function () {
    return properties ? Object.values(properties).map(function (item) {
      return {
        label: item.property_name,
        value: item.property_id
      };
    }) : null;
  }, [properties]);
  useEffect(function () {
    if (isFirstRender.current || purchaseResponse) {
      getRewardDetails();
      isFirstRender.current = false;
    }

    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return AppInterface.updateAppEvents();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [purchaseResponse]);

  var handlePurchase = function handlePurchase() {
    setIsPurchaseButtonDisabled(true);
    onPurchase(propertyList ? property : activeOffer.offerId);
  };

  var checkSelectedProperty = useCallback(function (selectedProperty) {
    if (!property) changeOfferProperty(selectedProperty);
  }, [property]);

  var changeOfferProperty = function changeOfferProperty(selectedProperty) {
    return selectedProperty && setProperty(selectedProperty);
  };

  var handleDefaultPurchase = function handleDefaultPurchase(propertyId) {
    purchaseReward(propertyId);

    if (rewardtype === PURCHASE_TYPE.VIP_ROOM_ACCESS) {
      setIsVipPurchase(true);
      dispatch(setPurchaseType(rewardtype));
    } else dispatch(setPurchaseType(''));
  };

  var handleStarPurchase = function handleStarPurchase(propertyId) {
    if (casinoIdStatus === PlayerStatus.PHYSICALLY_VERIFIED || casinoIdStatus === PlayerStatus.DIGITALLY_VERIFIED) {
      purchaseReward(propertyId);

      if (rewardtype === PURCHASE_TYPE.VIP_ROOM_ACCESS) {
        dispatch(setPurchaseType(rewardtype));
        dispatch(setVipRoomUnlocked(true));
      } else dispatch(setPurchaseType(''));
    } else if (!casinoId) if (rewardtype === PURCHASE_TYPE.COINS || rewardtype === PURCHASE_TYPE.VIP_ROOM_ACCESS) {
      dispatch(setPurchaseType(rewardtype));
      purchaseReward(propertyId);
    } else setShowKycPopUp(true);
  };

  var handleOnPurchase = generateRender({
    star: handleStarPurchase,
    default: handleDefaultPurchase
  });
  var onPurchase = debounce( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(propertyId) {
      var shouldShowLinkAccountPopUp;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              shouldShowLinkAccountPopUp = propertyList && isAccountLinked === 'no';

              if (!(shouldShowLinkAccountPopUp && !isStar)) {
                _context2.next = 5;
                break;
              }

              QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.LinkAccountForm));
              setIsPurchaseButtonDisabled(false);
              return _context2.abrupt("return");

            case 5:
              audio.onClick();
              handleOnPurchase(propertyId);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref5.apply(this, arguments);
    };
  }(), 300);

  var hideKycPopUp = function hideKycPopUp() {
    audio.onClick();
    setShowKycPopUp(false);
    return showKycPopUp;
  };

  var onKycCheck = function onKycCheck() {
    audio.onClick();

    if (KYCResult === 'Fail') {
      var _QueryParamsProxy$set2;

      QueryParamsProxy.setQueryParams((_QueryParamsProxy$set2 = {}, _defineProperty(_QueryParamsProxy$set2, RouteParamConstants.PARAM_MODAL, Screens.KYCLockout), _defineProperty(_QueryParamsProxy$set2, RouteParamConstants.PARAM_NAVIGATE_TO, undefined), _defineProperty(_QueryParamsProxy$set2, RouteParamConstants.PARAM_UPGRADE_TYPE, undefined), _QueryParamsProxy$set2));
    } else {
      var _QueryParamsProxy$set3;

      QueryParamsProxy.setQueryParams((_QueryParamsProxy$set3 = {}, _defineProperty(_QueryParamsProxy$set3, RouteParamConstants.PARAM_MODAL, Screens.UpgradeAccountFlow), _defineProperty(_QueryParamsProxy$set3, RouteParamConstants.PARAM_NAVIGATE_TO, Screens.RewardCenter), _defineProperty(_QueryParamsProxy$set3, RouteParamConstants.PARAM_UPGRADE_TYPE, UpgradeType.COMBINED), _QueryParamsProxy$set3));
    }
  };

  var onDismissPurchaseResponse = function onDismissPurchaseResponse() {
    audio.onClick();
    setPurchaseResponse(null);
    setIsPurchaseButtonDisabled(false);
  };

  var sendOfferRedeemedEvent = function sendOfferRedeemedEvent(offerInfo) {
    var amount = offerInfo.amount,
        pointsneeded = offerInfo.pointsneeded,
        r_id = offerInfo.r_id,
        rewardname = offerInfo.rewardname,
        rewardtype = offerInfo.rewardtype,
        propertyId = offerInfo.propertyId;
    var eventPayload = {
      loyalty_points_before: (parseInt(loyalty.value) + parseInt(pointsneeded)).toString(),
      loyalty_points: pointsneeded,
      name: rewardname,
      id: r_id,
      reward_type: rewardtype,
      coins: amount,
      balance_before: (parseInt(coin.value) - parseInt(amount)).toString(),
      prop_id: propertyId
    };
    Logger.sendEvent(EVENT_TYPES.OFFER_REDEEMED, eventPayload);
  };

  var purchaseReward = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(propertyId) {
      var _purchaseResponse, responseStatus, message;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return postPurchaseOffer({
                rid: activeOffer.offerId,
                propertyId: propertyId
              }).unwrap();

            case 3:
              _purchaseResponse = _context3.sent;

              if (!_purchaseResponse.success) {
                _context3.next = 9;
                break;
              }

              _context3.next = 7;
              return fetchGameRooms(true);

            case 7:
              refetchActiveConsumables();
              sendOfferRedeemedEvent(_objectSpread(_objectSpread({}, offerDetails), {}, {
                propertyId: propertyId
              }));

            case 9:
              responseStatus = _purchaseResponse.success ? PURCHASE_RESPONSE.SUCCESS : PURCHASE_RESPONSE.ERROR;
              message = responseStatus === PURCHASE_RESPONSE.SUCCESS ? _purchaseResponse.msg || _purchaseResponse.message : _purchaseResponse.error;
              setPurchaseResponse({
                status: responseStatus,
                message: message
              });
              _context3.next = 18;
              break;

            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](0);
              setIsPurchaseButtonDisabled(false);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                body: JSON.stringify(_context3.t0),
                code: ERROR_CODE.PURCHASE_OFFER_REQUEST_ERROR
              });

            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 14]]);
    }));

    return function purchaseReward(_x2) {
      return _ref6.apply(this, arguments);
    };
  }();

  var getRewardDetails = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var rewardDetailsResponse;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              audio.onClick();
              _context4.prev = 1;
              setIsLoading(true);
              _context4.next = 5;
              return postOfferDetail({
                offerId: activeOffer.offerId,
                rewardCenterBaseUrl: RewardsImageBaseURL
              }).unwrap();

            case 5:
              rewardDetailsResponse = _context4.sent;

              if (!rewardDetailsResponse.success) {
                _context4.next = 11;
                break;
              }

              setOfferDetails(rewardDetailsResponse === null || rewardDetailsResponse === void 0 ? void 0 : rewardDetailsResponse.offerDetails);
              setIsLoading(false);
              _context4.next = 12;
              break;

            case 11:
              throw new Error(rewardDetailsResponse.error);

            case 12:
              _context4.next = 17;
              break;

            case 14:
              _context4.prev = 14;
              _context4.t0 = _context4["catch"](1);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                body: JSON.stringify(_context4.t0),
                code: ERROR_CODE.GET_REWARD_DETAILS_REQUEST_ERROR
              });

            case 17:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 14]]);
    }));

    return function getRewardDetails() {
      return _ref7.apply(this, arguments);
    };
  }();

  var disabledButtonClick = function disabledButtonClick() {
    audio.onClick();
    var hasVIPPass = isVipRoomUnlocked && rewardtype === PURCHASE_TYPE.VIP_ROOM_ACCESS;
    var memberLevels = ['Gold', 'Platinum', 'Diamond'];
    if (hasVIPPass || memberLevels.includes(memberLevel)) QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.VipAccessFlow));
  };

  useEffect(function () {
    if (activeConsumables) dispatch(setActiveConsumables(activeConsumables));
  }, [activeConsumables, dispatch]);
  useEffect(function () {
    var _propertyList$;

    if (propertyList) checkSelectedProperty((_propertyList$ = propertyList[0]) === null || _propertyList$ === void 0 ? void 0 : _propertyList$.value); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertyList]);
  return {
    handlePurchase: handlePurchase,
    onDismissPurchaseResponse: onDismissPurchaseResponse,
    purchaseResponse: purchaseResponse,
    isLoading: isLoading,
    showKycPopUp: showKycPopUp,
    isVipPurchase: isVipPurchase,
    onKycCheck: onKycCheck,
    hideKycPopUp: hideKycPopUp,
    onDisabledButtonClick: disabledButtonClick,
    offerDetails: offerDetails,
    termsText: termsText,
    termsUrl: termsUrl,
    isPurchaseButtonDisabled: isPurchaseButtonDisabled,
    setIsPurchaseButtonDisabled: setIsPurchaseButtonDisabled,
    changeOfferProperty: changeOfferProperty,
    propertyList: propertyList
  };
};

export default useRewardCenterOfferDetails;